let React =                 require("react");

const ObservableUtil =         require('../../util/ObservableUtil.js');

let Utility =                  require("../../util/Utilities.js");
let CircuitsUtil =                  require("../../util/CircuitsUtil.js");
let LibraryLoader =            require("./LibraryLoader.js");

let ElementPreview =        require("./ElementPreview.jsx");
let DetailsElementPreview = require("./DetailsElementPreview.jsx");
let LoadingPlaceholder =    require("../cards/LoadingPlaceholder.jsx");

class LibraryPreview extends React.Component {

    constructor(){
        super();

        this.state = { showDetails : false, itemSelected: {},
                        component: [], symbol: [],
                        package: [], footprint: [] }

        this.showItem = this.showItem.bind(this);
        this.getElements = this.getElements.bind(this);
    }

    componentDidMount(){
        this.loadComponents(this.props.resource.id);
    }

    loadComponents(id){
        LibraryLoader.loadExplicit(this.props.handleError, id)
            .then(newState => {
                this.setState(newState);
                return LibraryLoader.loadImplicit(this.props.handleError, newState.implicits);
            })
            .then(({footprint = [], package: packages = [], symbol = []}) => {
                return LibraryLoader.addInfoContains({component: this.state.component,
                                                            symbol: [...this.state.symbol, ...symbol],
                                                            package: [...this.state.package, ...packages],
                                                            footprint: [...this.state.footprint, ...footprint]});
            })
            .then(newState => {
                ObservableUtil.callChangeSubscribers("libraryPackages", this.props.resource.id, newState.package.map(pkg => pkg[1]));
                return newState;
            })
            .then(newState => this.setState(LibraryLoader.sort(newState)))
    }

    getArrow(){
        return <svg width="9" height="6" xmlns="http://www.w3.org/2000/svg"> <use xlinkHref='#row' /> </svg>
    }

    getElements(elements){
        if(elements.length > 0){
            return elements.map(([id, info], index) => {
                return <ElementPreview key={`${id}-${info.type}${index}`} {...info} idSelected={this.state.itemSelected.id} showItem={this.showItem}/>
            })
        }else if(this.state.finished){
            return <div></div>
        }
        return <LoadingPlaceholder/>;
    }

    getNumElements(elements){
        if(elements.length > 0){
            return elements.length;
        }else if(this.state.finished){
            return 0;
        }
        return <LoadingPlaceholder/>;
    }

    getInfoMessage(){
        if(!this.props.resource.user_id){ return null};

        let text = <div className="libraryPreview__instructions__text">
                To use this library, launch the Library Manager in <a href="https://www.autodesk.com/products/eagle/overview" target="_blank">EAGLE</a> or <a href="https://www.autodesk.com/products/fusion-360/overview" target="_blank">Fusion</a>.</div>

        if(this.props.current_user_id === this.props.resource.user_id){
        text = <div className="libraryPreview__instructions__text">
                    To edit this library in <a href="https://www.autodesk.com/products/fusion-360/overview" target="_blank">Fusion</a>, go to File {">"} New Library, then select "Open" from the toolbar.</div>
        }

        return  <div className="libraryPreview__instructions">
                    <div className="libraryPreview__instructions__contIcon">
                        <svg width="23" height="23" xmlns="http://www.w3.org/2000/svg">
                            <use xlinkHref='#warning' className="info" />
                        </svg>
                    </div>
                    {text}
                </div>
    }

    showItem({id, type}){
        this.setState({ showDetails: true, itemSelected: LibraryLoader.mapElements.get(type).get(id)},
                        ()=> {
                            this.open(this[`r${type}`], "add");
                            let item = document.querySelector(".elementPreview.selected");
                            let currentPosition = this.refContainer.clientHeight + this.refContainer.scrollTop;
                            if(this.refContainer.scrollTop > item.offsetTop || currentPosition < item.offsetTop){
                                this.refContainer.scrollTop = item.offsetTop - (this.refContainer.clientHeight / 2);
                            }
                        });
    }

    open(element, type = "toggle"){
        element.classList[type]("show");
    }


    render() {
        let {name, hub_name, updated_at: updateAt, summary} = this.props.resource;
        updateAt = Utility.formatDateMonthString(updateAt);
        summary = Utility.formatDescription(summary);
        const version = CircuitsUtil.getMostRecentVersion(this.props.resource);
        const { component, symbol, package: packages, footprint} = this.state;

        return  <div className="libraryPreview">
                    <div className="libraryPreview__container">
                        <div className="libraryPreview__container__elements" ref={div => this.refContainer = div}>
                            <div className="libraryPreview__container__elements__titles">
                                <div> Type </div> <div> Name </div> <div> Summary </div> <div> Version </div> <div> Date Created </div>
                            </div>
                            <div className="libraryPreview__container__elements__cont show" ref={div => this.rcomponent = div}>
                                <div className="libraryPreview__container__elements__header" onClick={() => this.open(this.rcomponent)}>
                                    <div className="libraryPreview__container__elements__header__arrow">{this.getArrow()}</div>
                                    <div className="libraryPreview__container__elements__header__title">Components [{component.length}]</div>
                                </div>
                                    {this.getElements(component)}
                            </div>
                            <div className="libraryPreview__container__elements__cont show" ref={div => this.rsymbol = div}>
                                <div className="libraryPreview__container__elements__header" onClick={() => this.open(this.rsymbol)}>
                                    <div className="libraryPreview__container__elements__header__arrow">{this.getArrow()}</div>
                                    <div className="libraryPreview__container__elements__header__title">Symbol [{symbol.length}]</div>
                                </div>
                                    {this.getElements(symbol)}
                            </div>
                            <div className="libraryPreview__container__elements__cont show" ref={div => this.rpackage = div}>
                                <div className="libraryPreview__container__elements__header" onClick={() => this.open(this.rpackage)}>
                                    <div className="libraryPreview__container__elements__header__arrow">{this.getArrow()}</div>
                                    <div className="libraryPreview__container__elements__header__title">Package [{packages.length}]</div>
                                </div>
                                    {this.getElements(packages)}
                            </div>
                            <div className="libraryPreview__container__elements__cont show" ref={div => this.rfootprint = div}>
                                <div className="libraryPreview__container__elements__header" onClick={() => this.open(this.rfootprint)}>
                                    <div className="libraryPreview__container__elements__header__arrow">{this.getArrow()}</div>
                                    <div className="libraryPreview__container__elements__header__title">Footprint [{footprint.length}]</div>
                                </div>
                                    {this.getElements(footprint)}
                            </div>
                        </div>
                        <div className="libraryPreview__container__details">
                            {this.state.showDetails ?
                                <DetailsElementPreview {...this.state.itemSelected} showItem={this.showItem}/>
                                :<div className="libraryPreview__container__details__info">
                                    <p className="libraryPreview__container__details__info__name">{name}</p>
                                    <p className="libraryPreview__container__details__info__title">Library info</p>
                                    <div className="libraryPreview__container__details__info__contElements">
                                        <p className="name">Components</p><div className="num">{this.getNumElements(component)}</div>
                                        <p className="name">Symbols</p><div className="num">{this.getNumElements(symbol)}</div>
                                        <p className="name">Packages</p><div className="num">{this.getNumElements(packages)}</div>
                                        <p className="name">Footprints</p><div className="num">{this.getNumElements(footprint)}</div>
                                    </div>
                                    <div className="libraryPreview__container__details__info__contInfo">
                                        <p className="name">{fullHubAlias}</p><p>{hub_name}</p>
                                        <p className="name">Date Modified</p><p>{updateAt}</p>
                                        <p className="name">Summary</p><p dangerouslySetInnerHTML={{__html: Utility.formatDescription(summary)}}></p>
                                        <p className="name">Version</p><p>{version === -1 ? "": version}</p>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    {this.getInfoMessage()}
                </div>
    }
};

module.exports = LibraryPreview;
